import React, { Component } from 'react';
import { FormGroup, FormControl, Button, Grid, Row, Jumbotron, InputGroup, Glyphicon, Col } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';
import '../css/App.css';
import Logo from './Logo';
import Alert from './Alert';
import SendButton from './SendButton';
import axios from 'axios';
import Loading from './Loading';
import { apiUrl } from '../config.json'

bootstrapUtils.addStyle(Button, 'custom');

const commonPasswords = ['012345', '123456', '234567', '345678', '456789', '987654', '654321', '543210', '123123', '123321', '121212', '112233']

export default class ResetPassword extends Component {
    state = {
        message: '',
        password: '',
        statusRequest: '',
        loading: false
    };

    getValidationState = () => {
        const length = this.state.password.length;
        if (length === 6) {
            return 'success'
        }
        if (length > 0 || length > 6) {
            return 'error';
        }
        return null;
    }

    handleChange = (e) => {
        const valueInput = e.target.value;
        if (valueInput.length === 7 || valueInput == null) {
            return
        }

        this.setState({ password: e.target.value });
    }

    checkCommonPasswords = () => {
      const { password } = this.state
      if (commonPasswords.includes(password)) {
        return '11111, 222222, 123456.'
      }
      if (password.match(/(\d)\1\1/g)) {
        return '222333, 155521, 444221.'
      }
      if (password.match(/(\d)\1/g) && password.match(/(\d)\1/g).length === 3) {
        return '222333, 112211, 337722.'
      }
      return ''
    } 

    send = async (event) => {
        event.preventDefault();
        this.setState({ loading: true })
        const errorExamples = this.checkCommonPasswords()
        if (errorExamples) {
          this.setState({ loading: false, statusRequest: 500, message: `A senha é muita fraca evite senhas como: ${errorExamples}` })
          return
        }
        const data = {
            token: this.props.match.params.token,
            password: this.state.password
        }

        const headers = {
            'Content-Type': 'application/json'
        }

        try {
            const response = await axios.post(`${apiUrl}/account/public/password/reset`, data, headers)
            this.setState({ loading: false })
            if (!response.error) {
                this.setState({ statusRequest: 200, message: 'Senha alterada com sucesso!' });
                return
            }
            this.setState({ statusRequest: 500, message: 'Algo aconteceu, estamos trabalhando para melhorar!' });
        } catch (error) {
            this.setState({ loading: false })
            if (error.response === undefined) {
                this.setState({ statusRequest: 500, message: 'Algo aconteceu, estamos trabalhando para melhorar!' });
                return
            }
            if (error.response.data.code === 'PASSWORD_REJECTED') {
              this.setState({ statusRequest: 500, message: 'Sua senha não pode ser igual a anterior' });
              return
          }
            if (error.response.data.error) {
                this.setState({ statusRequest: 500, message: error.response.data.message });
            }
            this.setState({ statusRequest: 500, message: 'Algo aconteceu, estamos trabalhando para melhorar!' });

        }
    }

    render() {
        return (
            <Grid>
                <Loading visible={this.state.loading} />
                <Row align="center">
                    <Col xs={12} md={12}>
                        <Logo />
                        <br />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <br />
                        <Alert statusRequest={this.state.statusRequest} message={this.state.message} />
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12}>
                        <Jumbotron>
                            <form onSubmit={this.send}>
                                <FormGroup>
                                    <InputGroup>
                                        <FormControl
                                            type="text"
                                            value={this.props.match.params.email}
                                            disabled
                                        />
                                        <InputGroup.Addon>
                                            <Glyphicon glyph="envelope" />
                                        </InputGroup.Addon>
                                    </InputGroup>
                                </FormGroup>

                                <FormGroup
                                    controlId="formBasicText"
                                    validationState={this.getValidationState()}
                                >
                                    <FormControl
                                        type="number"
                                        value={this.state.password}
                                        placeholder="Digite a nova senha!"
                                        style={{ WebkitTextSecurity: 'disc' }}
                                        onChange={this.handleChange}
                                    />

                                    <FormControl.Feedback />

                                </FormGroup>

                                <FormGroup align="center">
                                    <SendButton loading statusRequest={this.state.statusRequest} password={this.state.password} />
                                </FormGroup>
                            </form>
                        </Jumbotron>
                    </Col>
                </Row>
            </Grid>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ResetPassword.js